import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    // vue-chartjsにはreactivePropというよくできたmixinがあるが、これはoptionsの変更には対応しない。
    // 週・月の切り替わりでoptions.scales.yAxes[any].ticks.max（ながっ）が変更されたときにupdate()ではなくrenderChart()をコールしてoptionsも更新してほしいので、マニュアルになるがシンプルにwatcherをつけることにする。
    chartData () {
      this.renderChart(this.chartData, this.options)
      this.$emit('chart:rendered')
    }
  }
}
